import "./HeroImageStyles.css";
import IntroImg from "../assets/profile.JPG";
import { Link } from "react-router-dom";
import TypeWriterEffect from "react-typewriter-effect";
import { FaGithub, FaLinkedin, FaYoutube, FaTwitter, FaFacebook, FaInstagram, FaDiscord } from "react-icons/fa";
import React, { useState, useEffect } from "react";


const HeroImage = () => {
  const [years, setYears] = useState(0);
const [projects, setProjects] = useState(0);
const [techs, setTechs] = useState(0);

useEffect(() => {
  const duration = 3000;
  const frameRate = 30;
  const steps = duration / frameRate;
  const target = { years: 6, projects: 21, techs: 9 };

  let currentStep = 0;

  const interval = setInterval(() => {
      currentStep++;
      setYears(Math.ceil((target.years * currentStep) / steps));
      setProjects(Math.ceil((target.projects * currentStep) / steps));
      setTechs(Math.ceil((target.techs * currentStep) / steps));

      if (currentStep >= steps) {
        clearInterval(interval);
      }
    }, frameRate);
  }, []);

  return (
    <div className="container">
      <div className="hero-left">
        <p className="hero-role">Computer Engineer</p>
        <h1>
          <span className="highlight">Sir Dhan A. Mota</span>
        </h1>
        <TypeWriterEffect
          textStyle={{ textAlign: "left", fontSize: "1.2rem" }}
          startDelay={1000}
          cursorColor="#e85a4f"
          multiText={["WEB DESIGNER", "WEB DEVELOPER", "SYSTEMS DEVELOPER"]}
          multiTextDelay={2000}
          typeSpeed={50}
          multiTextLoop
        />
        <p className="hero-desc">
          Step into a space where design, innovation, and excellence come to life, crafted to inspire, engage, and leave a lasting impression.
        </p>
        <div className="hero-buttons">
          <a href="https://drive.google.com/file/d/1HLWjfW26Jq2bZMJzrJzQCzoLfYMRC6XU/view?usp=sharing" target="_blank" className="btn download-btn" download>
            Download CV <span>↓</span>
          </a>
          <div className="hero-socials">
            <a href="https://www.facebook.com/dhan013x" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
            <a href="https://www.instagram.com/dhan.m_/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://www.linkedin.com/in/sir-dhan-mota-458537232/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            <a href="https://discordapp.com/users/573120915932708924/" target="_blank" rel="noopener noreferrer"><FaDiscord /></a>
          </div>
        </div>
        <div className="hero-stats">
          <div><span>{years}</span><br />Years of experience</div>
          <div><span>{projects}</span><br />Projects completed</div>
          <div><span>{techs}</span><br />Technologies mastered</div>
        </div>
      </div>
      <div className="hero-right">
        <div className="hero-img-wrapper">
          <div className="hero-img-circle">
            <img className="intro-img" src={IntroImg} alt="profile" />
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default HeroImage;
